import React from 'react'

const ErrorList = ({ errors }) => {
    return (
        <div className="errorList">
            <ul style={{ padding: '10px 20px' }}>
                {
                    errors?.email?.map(
                        (item, index) => <li style={{ color: '#D84040', fontWeight: 700 }} key={index}>{item}</li>
                    )
                }
                {
                    errors?.password?.map(
                        (item, index) => <li style={{ color: '#D84040', fontWeight: 700 }} key={index}>{item}</li>
                    )
                }
            </ul>
        </div>
    )
}

export default ErrorList
